module.exports = __webpack_public_path__ + "static/presidents-message-74693b7e8689d2c27989460aaf2bc299.jpg";